// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {ModalCourseSchedulingSessionFormModuleLayout} from 'app_components/modules/admin/courseScheduling/modalCourseSchedulingSessionForm'
// @end

// @import events
// @end

// @import utils
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import DurationFieldService from 'app_services/components/durationFieldService'
// @end

// @import types
// @end

// @ADD Component types
interface IModalCourseSchedulingSessionFormModuleProps {
  open: boolean
  handleClose: (data:any)=>void
  editData?: any
  minDate?: string
  endDate?: string
}
interface IModalCourseSchedulingSessionFormModuleState {
  customErrors: any
  processing: boolean
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ModalCourseSchedulingSessionFormModule extends Component<IModalCourseSchedulingSessionFormModuleProps, IModalCourseSchedulingSessionFormModuleState> {

  private i18nUtil: I18nUtil
  private durationFieldService: DurationFieldService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IModalCourseSchedulingSessionFormModuleProps) {
    super(props)
    this.state = {
      customErrors: null,
      processing: false
    }

    this.durationFieldService = new DurationFieldService()
    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}



  // @Add custom methods
  onHandleSubmit = async (data: any) => {
    this.setState({processing: true, customErrors: null})

    let customErrors: any = {}
    if (data.duration) {
      data.duration = this.durationFieldService.getSecondsFromDuration(data.duration)
      if (data.duration === 0) {
        customErrors['duration_invalid'] = this.i18nUtil.getTranslate('modules.modal_course_scheduling_session_form.duration_invalid')
      }
    }

    // @INFO: Si existen campos con error retorno
    if (Object.keys(customErrors).length > 0) {
      this.setState({customErrors, processing: false})
      return false
    }

    this.setState({processing: false})
    const dataToSend = { ...data, startDate: new Date(data.startDate) }
    this.props.handleClose({status: true, data: dataToSend})
  }

  render() {
    return(
      <ModalCourseSchedulingSessionFormModuleLayout
        open={this.props.open}
        handleClose={this.props.handleClose}
        onHandleSubmit={this.onHandleSubmit}
        customErrors={this.state.customErrors}
        processing={this.state.processing}
        editData={this.props.editData}
        minDate={this.props.minDate}
        endDate={this.props.endDate}
      />
    )
  }
}

export default connect(mapStatesToProps)(ModalCourseSchedulingSessionFormModule)
